/**
 * @mixin
 */
export default {
    renderError (h) {
        return h('div', {}, [
            h('v-alert', {
                props: {
                    type: 'error',
                    value: true
                }
            }, 'There was an error displaying this item.  If this problem persists ' +
                'please contact your system administrator.')
        ])
    }
}
